import { Injectable } from '@angular/core';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { FvmsApiBaseService } from "./fvms.api.base.service";

@Injectable({providedIn: 'root'})
export class FvmsApiDtgUserService extends FvmsApiBaseService {
    constructor(
        public http:HttpClient
    ) {
        super(http);
    }

    getListUser(searchInfo:any,pagingInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/user";
        url += "/manage/user/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        // searchInfo = {
        //     "companyId":1
        //     ,"dtgUserId":1
        //     ,"dtgTeamId":1
        //     ,"searchValue":"검색어"
        // };
        // pagingInfo = {
        //     "curPage":1
        //     ,"pageSize":100
        // };
        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":pagingInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    getOneUser(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/user";
        url += "/manage/user/detail";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        // searchInfo = {
        //     "companyId":1
        //     ,"dtgTeamId":1
        // };
        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":null
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    getListUserGroup(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/user";
        url += "/manage/user/group/list";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        // searchInfo = {
        //     "limitUserGroupId":1
        // };
        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":null
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    upsertUser(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/user";
        url += "/manage/user/upsert";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        // searchInfo = {
        //     "companyId":1
        //     ,"dtgTeamId":1
        // };
        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":null
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    moveUserCompany(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/user";
        url += "/manage/user/move/company";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });
        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":null
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    getOneUserCarRun(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/user";
        url += "/manage/user/car/run/detail";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":null
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    getListUserCarRun(searchInfo:any,pagingInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + '/dtg/user';
        url += '/manage/user/car/run/list';

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });
        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":pagingInfo
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));
        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    checkDtgUserCarRun(searchInfo:any):Observable<any> {
        let url = this.getApiBaseUrl() +'/dtg/user';
        url += '/manage/user/car/run/check';

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(searchInfo));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    upsertUserCarRun(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/user";
        url += "/manage/user/car/run/upsert";
        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });
        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":null
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    upsertUserCarRunFile(baseInfo:any, file: File): Observable<any> {
        let url = this.getApiBaseUrl() + "/dtg/user";
        url += "/manage/user/car/run/upsertbulk";
        // Content-Type을 명시하면 Backend에서 오류발생
        let header = new HttpHeaders({
            "Content-Type":"multipart/formdata"
        });

        let tempObj: any = {
            "searchInfo":baseInfo
            ,"pagingInfo":null
        }

        // target file
        let data = new FormData();
        data.append('data', new Blob([JSON.stringify(tempObj)], { type: "application/json"}));
        data.append('file', file);

        // return this.http.post<any>(url, data, {headers: header})

        // let result = this.http.post<any>(url, data);
        // let blob = new Blob([result], {type : 'application/vnd.openxmlformats-officedocument.presentationml.presentation;charset=UTF-8'})
        // FileSaver.saveAs()

        let result = this.http.post(url, data, { responseType : 'blob' });
        return result;
    }

    // 선택된 배차정보 삭제
    deleteUserCarRun(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/user";
        url += "/manage/user/car/run/delete";
        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });
        let tmpPostObject = {
            "searchInfo":searchInfo
        };
        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));
        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }

    // 조건에 해당하는 데이터 삭제
    deleteInBulkDtgUserCarRun(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/user";
        url += "/manage/user/car/run/deletebulk";
        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });
        let tmpPostObject = {
            "searchInfo":searchInfo
        };
        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));
        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url, bodyData, { headers : header });
    }

    upsertUserCarRunLast(searchInfo:any):Observable<any>{
        let url = this.getApiBaseUrl() + "/dtg/user";
        url += "/manage/user/car/run/last/upsert";

        let header = new HttpHeaders({
            "Content-Type":"application/json"
        });

        // searchInfo = {
        //     "companyId":1
        //     ,"dtgTeamId":1
        // };
        let tmpPostObject = {
            "searchInfo":searchInfo
            ,"pagingInfo":null
        };

        //객체가 연결되어 있어서 주입된 객체에 값을 변경하면 ui의 값도 같이 바뀐다
        //때문에 객체를 복사해서 사용
        let tmpData = JSON.parse(JSON.stringify(tmpPostObject));

        let bodyData = JSON.stringify(tmpData);

        return this.http.post<any>(url,bodyData,{ headers : header });
    }
}
